import { render, staticRenderFns } from "./MarcasVehiculo.vue?vue&type=template&id=9dcb9ada&"
import script from "./MarcasVehiculo.vue?vue&type=script&lang=js&"
export * from "./MarcasVehiculo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports